function Brand() {
  return (
    <div className="brand">
      <div className="brand-logo">bluprint</div>
      <div className="brand-tagline">AI Relationship Intelligence</div>
    </div>
  );
}

export default Brand;
